<template>
  <v-container fluid class="text-center">
    <Loader :loading="loading" />
    <Table-Container title="Autorizar pagos" :exportInfo="items">
      <template v-slot:buttons>
        <Basic-Btn text="Actualizar" color="success" icon="mdi-refresh" @click="refresh()" :loading="loading" />
      </template>
      <template v-slot:search>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
      </template>
      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search" :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [20, 50, -1] }" :items-per-page="10" item-key="id" class="elevation-1" dense>
        <v-progress-linear slot="progress" color="secondary" indeterminate></v-progress-linear>
        <template v-slot:[`item.zona`]="{ item }">
          {{ item.zona ? item.zona.nombre : "Sin asignar" }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip left
            ><template v-slot:activator="{ on, attrs }"><v-icon class="mr-2" size="22" color="success" dark v-bind="attrs" v-on="on" :disabled="loading" @click="view(item, true)">mdi-check</v-icon></template
            ><span>Aprobar</span></v-tooltip
          >
          <v-tooltip right
            ><template v-slot:activator="{ on, attrs }"><v-icon class="mr-2" size="22" color="error" dark v-bind="attrs" v-on="on" :disabled="loading" @click="view(item, false)">mdi-close</v-icon></template
            ><span>Rechazar</span></v-tooltip
          >
        </template>
        <template v-slot:[`footer.page-text`]="props"> Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }} </template>
        <template v-slot:no-data> No hay información disponible </template>
        <template v-slot:no-results> No se obtuvieron resultados </template>
      </v-data-table>
    </Table-Container>
    <Dialog-Form :estate="dialogs.update" :title="(actionMode ? 'Aprobar' : 'Rechazar') +  ' pago pendiente'">
      <template v-slot:buttons>
        <Basic-Btn text="Cancelar" color="error" icon="mdi-close" @click="cancel()" :loading="loading" />
        <Basic-Btn :text="actionMode ? 'Aprobar' : 'Rechazar'" color="success" icon="mdi-check" @click="actionMode ? approve() : reject()" :loading="loading" />
      </template>
      <v-form ref="formUpdate" lazy-validation>
        <v-row>
          <v-col cols="12" md="12">
            <v-textarea v-model="forms.update.comentarios" label="Comentarios" prepend-icon="mdi-message-text-outline" :rules="rules.max2000" :disabled="loading" outlined dense required></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </Dialog-Form>
    <BasicAlert :active.sync="alert.active" :msg="alert.msg" :color="alert.color" />
  </v-container>
</template>

<script>
import services from "@/utils/services";
import { Loader, DialogForm, BasicAlert, TableContainer, BasicBtn, } from "@/components";

export default {
  name: "pending-payments",
  components: {
    Loader,
    DialogForm,
    BasicAlert,
    TableContainer,
    BasicBtn,
  },
  data: () => ({
    loading: false,
    alert: {
      active: false,
      color: "error",
      msg: "",
    },
    search: "",
    headers: [
      { text: "ID", align: "left", sortable: true, value: "id" },
      { text: "ID de solicitud", align: "left", sortable: true, value: "solicitud_prestamo" },
      { text: "Grupo", align: "left", sortable: true, value: "grupo" },
      { text: "Monto aprobado", align: "left", sortable: true, value: "monto_aprobado" },
      { text: "Semana", align: "left", sortable: true, value: "semana" },
      { text: "Usuario creador de pago", align: "left", sortable: true, value: "usuario_creacion_pago" },
      { text: "Fecha de pago", align: "left", sortable: true, value: "fecha_pago" },
      { text: "Monto de pago", align: "left", sortable: true, value: "monto_pago" },
      { text: "Estatus de pago", align: "left", sortable: true, value: "estatus_pago" },
      { text: "Acciones", align: "left", sortable: false, value: "actions" },
    ],
    items: [],
    selected: [],
    deleted: null,
    actionMode: false,
    forms: {
      update: {
        id: '',
        observacion: "",
      },
    },
    rules: {
      max2000: [(v) => !!v || "El campo es requerido", (v) => (v && v.length <= 2000) || "El campo excede la longitud máxima"],
    },
    dialogs: {
      update: false,
    },
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      this.axios
        .get(services.routes.paymentDetail + '/pending')
        .then((response) => {
          this.items = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
    if (this.dialogs.update) {
        this.dialogs.update = false;
      }
    },
    view(data, bool) {
      this.actionMode = bool
      this.forms.update = JSON.parse(JSON.stringify(data));
      this.dialogs.update = true;
    },
    approve() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.forms.update));
        this.axios
          .put(services.routes.paymentDetail + '/approve', { data })
          .then(() => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Pago actualizado exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "La información es incorrecta";
      }
    },
    reject() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.forms.update));
        this.axios
          .post(services.routes.paymentDetail + '/reject', { data })
          .then(() => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Pago actualizado exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "La información es incorrecta";
      }
    },
  },
};
</script>

<style scoped></style>
